// @ts-nocheck
import React, { useState } from 'react'
import Popup from '../../Popup/Popup'
import Success from '../../Success/Success'
import apiFetch from '../../../api/apiFetch'
import TargetLimitBox from '../../CreateExerciseWizard/components/TargetLimitBox'
import Toggle from '../../../globalcomponents/Toggle'
import Spinner from '../../Spinner/Spinner'

function EditPerTargetLimits(props) {
    const initialLimits = props.data.PER_TARGET_LIMITS
        ? JSON.parse(props.data.PER_TARGET_LIMITS)
        : null

    const [allowDIR, setAllowDIR] = useState(!!(initialLimits?.allowDIR))
    const [allowMOT, setAllowMOT] = useState(!!(initialLimits?.allowMOT))
    const [excludeNTAddsFromCap, setExcludeNTAddsFromCap] = useState(!!(initialLimits?.excludeNTAddsFromCap))
    const [perTargetLimits, setPerTargetLimits] = useState(initialLimits)
    const [success, setSuccess] = useState()
    const limitType = props.data.LIMIT_TYPE ?? 'percent'

    const submit = () => {
        setSuccess(null)
        apiFetch(props.endpoints.editPerTargetLimits, {
            id: props.data.ID,
            perTargetLimits: JSON.stringify({ ...perTargetLimits, allowDIR, allowMOT, excludeNTAddsFromCap })
        }).then((data) => {
            props.setData(data)
            setSuccess(true)
        })
    }

    if (!perTargetLimits) {
        return (
            <Popup {...props} title={"Edit Per Target Limits"} body={
                <div className={"pop-body"}>
                    <div style={{ padding: '20px', color: '#888', fontSize: 12 }}>
                        No per-target limit configuration found for this exercise.
                        Per-target limits are set when the exercise is created via the Add Exercise wizard.
                    </div>
                    <div className={"pop-buttonRow"}>
                        <button type="button" id={"pop-cancel"} onClick={props.close}>CLOSE</button>
                    </div>
                </div>
            } />
        )
    }

    const targetLimitBoxes = Object.keys(perTargetLimits)
        .filter(key => key !== 'allowDIR' && key !== 'allowMOT' && key !== 'excludeNTAddsFromCap')
        .map(key => (
            <TargetLimitBox
                key={key}
                data={perTargetLimits}
                setData={setPerTargetLimits}
                dataKey={key}
                valid={true}
                limitType={limitType}
            />
        ))

    const allPerTargetUnlimited = Object.keys(perTargetLimits).every(
        key => parseInt(perTargetLimits[key]?.maxChanges) === 0
    );
    const showUnlimitedAdvisory = allPerTargetUnlimited && parseInt(props.data.MAX_CHANGES_PER_TERRITORY) > 0;

    const allPerTargetCallsUnlimited = Object.keys(perTargetLimits).every(
        key => parseInt(perTargetLimits[key]?.maxCalls) === 0
    );
    const showCallAdvisory = allPerTargetCallsUnlimited && parseInt(props.data.MAX_CALLS_PER_TERRITORY) > 0;

    const limitSymbol = limitType === 'static' ? '#' : '%';
    const advisories = [
        showUnlimitedAdvisory && `⚠️ No per-target reclassification limits set — the ${props.data.MAX_CHANGES_PER_TERRITORY}${limitSymbol} territory cap will be the only guardrail.`,
        showCallAdvisory && `⚠️ No per-target call limits set — the ${props.data.MAX_CALLS_PER_TERRITORY}${limitSymbol} territory call cap will be the only guardrail.`,
    ].filter(Boolean);

    const body = (
        <div className={"pop-body"}>
            <div style={{ fontSize: 12, color: '#555', marginBottom: advisories.length ? 0 : 8 }}>
                The default target config for this team/exercise are listed below and toggled on. Use "0" for unlimited.
            </div>
            <div style={{ border: '1px solid #e0e0e0', borderRadius: 6, margin: '8px 0 6px', overflow: 'hidden' }}>
                {[
                    { active: allowDIR,             set: setAllowDIR,             accent: '#ce93d8', color: '#6a1b9a', label: 'Allow DIR (Deceased / Inactive / Retired) — reps can mark HCPs as DIR without counting against change limits' },
                    { active: allowMOT,             set: setAllowMOT,             accent: '#90caf9', color: '#1565c0', label: 'Allow MOT (Moved Out of Territory) — reps can flag HCPs as moved without counting against change limits or changing the target type' },
                    { active: excludeNTAddsFromCap, set: setExcludeNTAddsFromCap, accent: '#ffcc80', color: '#e65100', label: 'Exclude NT upgrades from reclassification cap — NT→A/B/C adds do not count against the territory change limit' },
                ].map((row, i, arr) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 12px', borderBottom: i < arr.length - 1 ? '1px solid #f0f0f0' : 'none', borderLeft: `4px solid ${row.accent}` }}>
                        <div style={{ flexShrink: 0, width: 44 }}><Toggle active={row.active} click={() => row.set(v => !v)} /></div>
                        <span style={{ flex: 1, fontSize: 11.5, fontWeight: 500, color: row.color, lineHeight: 1.35 }}>{row.label}</span>
                    </div>
                ))}
            </div>
            {advisories.length > 0 && (
                <div style={{ margin: '6px 0 8px' }}>
                    {advisories.map((a, i) => (
                        <div key={i} style={{ fontSize: 12, color: '#b87c00', fontWeight: 500 }}>{a}</div>
                    ))}
                </div>
            )}
            <div style={{ maxHeight: '65vh', overflowY: 'auto', padding: '0 4px', width: '100%' }}>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
                    gap: 20,
                    padding: '8px 0',
                    width: '100%',
                    minWidth: 520,
                }}>
                    {targetLimitBoxes}
                </div>
            </div>
            <div className={"pop-buttonRow"}>
                <button type="button" id={"pop-cancel"} onClick={props.close}>CLOSE</button>
                <button id={"pop-submit"} onClick={submit}>SUBMIT</button>
            </div>
        </div>
    )

    if (success !== undefined) {
        return <Success {...props} success={success} successMessage={"Per-target limits updated successfully."} />
    }
    return <Popup {...props} body={body} title={"Edit Per Target Limits"} />
}

export default EditPerTargetLimits
